export default {
  labels: {
    google_place: 'Google place',
    live: 'Live',
    setting_up: 'În configurare',
  },
  buttons: {
    confirm: 'Confirmă',
    cancel: 'Anulează',
    continue_setup: 'Continuați configurarea',
  },
  delete_confirmation: 'Ești sigur?',
};
